var map = {
	"./add-order.png": "4660",
	"./banner.png": "ec24",
	"./edit-temp.png": "7710",
	"./load.png": "8b13",
	"./logo.png": "cf05",
	"./logo.svg": "9b19",
	"./logo2.png": "5fbe",
	"./logo3.png": "d092",
	"./neumobot.png": "eaa9",
	"./neumocabeza.png": "0b44",
	"./search-options.png": "8241",
	"./search-price.png": "b339",
	"./search-roles.png": "88e1",
	"./search-service-temp.png": "ef7e",
	"./search-session-temp.png": "adb4",
	"./search-temp.png": "717c",
	"./search-users.png": "eea9",
	"./search.png": "bbc5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";